import { render, staticRenderFns } from "./TaxSlabEdit.vue?vue&type=template&id=329610bd&scoped=true"
import script from "./TaxSlabEdit.vue?vue&type=script&lang=js"
export * from "./TaxSlabEdit.vue?vue&type=script&lang=js"
import style0 from "./TaxSlabEdit.vue?vue&type=style&index=0&id=329610bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329610bd",
  null
  
)

export default component.exports